import React from 'react';

import { withController, WithControllerInjectedProps } from 'react-scroll-parallax';

import { LazyImage, LazyImageProps } from "components/Image/Index";

type IOwnProps = LazyImageProps & WithControllerInjectedProps;

type IProps = IOwnProps;

const InsideParallaxImageComponent: React.FC<IProps> = props => {
  const updateParallaxComponents = () => {
    if (props.onImageLoad)
      props.onImageLoad();
    props.parallaxController.update();
  };

  return (
    <LazyImage
      {...props}
      onImageLoad={updateParallaxComponents}
    />
  );
};

// Wire up the React component to the pageSection
export const InsideParallaxImage = withController(InsideParallaxImageComponent);
